export enum SalonStatusType {
  PendingApproval = "PendingApproval", // Onay bekliyor
  Approved = "Approved", // Onaylandı
  PaymentDueSoon = "PaymentDueSoon", // Ödeme son 1 hafta
  PaymentOverdue = "PaymentOverdue", // Ödeme gecikmesi
  SuspendedForPayment = "SuspendedForPayment", // Ödeme sebebiyle kapandı
  ManuallySuspended = "ManuallySuspended", // Yönetici tarafından manuel askıya alındı
  PermanentlyClosed = "PermanentlyClosed", // Kalıcı olarak kapandı
  UnderReview = "UnderReview", // İnceleme sürecinde (şikayet, problem vs.)
  Trial = "Trial", // Deneme süresi aktif
  Inactive = "Inactive", // Hiç kullanılmamış ya da devre dışı
}
